module.exports = __webpack_public_path__ + "static/media/chart.f1eabf50.png";